import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: "desktop"
}

export const responsiveViewSlice = createSlice({
  name: 'responsiveView',
  initialState,
  reducers: {
    setResponsiveView: (state, action) => {
      if(action.payload < 351) {
        state.value = "teeny";
      }
      else if(action.payload < 769) {
        state.value = "mobile";
      }
      else if (action.payload < 1024) {
        state.value = "tablet";
      }
      else {
        state.value = "desktop";
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { setResponsiveView } = responsiveViewSlice.actions;

export default responsiveViewSlice.reducer;